import { Controller } from "@hotwired/stimulus"
import { rethrowUnlessAbort } from "../../utils/fetch-error.util"

export default class extends Controller {
  static outlets = ["documents--item"]

  // todo: this method is called twice need to fix it
  setTaxDocumentsSelectOptions(customerId) {
    const workspaceId = document.body.getAttribute("data-params-workspace-id")
    const baseUrl = window.location.origin
    const document_id = this.element.dataset.document_id
    fetch(`${baseUrl}/${workspaceId}/tax_document_options?customer_id=${customerId}&document_id=${document_id}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch(rethrowUnlessAbort)
  }

  taxDocumentSettle(event) {
    const workspaceId = document.body.getAttribute("data-params-workspace-id")
    const advancePaymentDeduction = document.getElementById("invoice_advance_payment_deduction")
    if (advancePaymentDeduction.value === "") {
      advancePaymentDeduction.value = 0
    }
    const taxDocumentId = event.target.getAttribute("data-tax-document-id")
    const taxDocumentAdvancePayment = event.target.getAttribute("data-advance-payment")
    const baseUrl = window.location.origin
    let url = ""
    if (event.target.checked) {
      advancePaymentDeduction.value = (
        parseFloat(advancePaymentDeduction.value) + parseFloat(taxDocumentAdvancePayment)
      ).toFixed(2)
      url = `${baseUrl}/${workspaceId}/settle_tax_documents/${taxDocumentId}`
    } else {
      advancePaymentDeduction.value = (
        parseFloat(advancePaymentDeduction.value) - parseFloat(taxDocumentAdvancePayment)
      ).toFixed(2)
      url = `${baseUrl}/${workspaceId}/unsettle_tax_documents/${taxDocumentId}`
    }
    if (this.hasDocumentsItemOutlet) {
      this.documentsItemOutlet.connect()
    }
    fetch(url, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch(rethrowUnlessAbort)
  }
}
